// Technical skills for job postings
export const TECHNICAL_SKILLS = [
  'JavaScript',
  'TypeScript',
  'React',
  'Node.js',
  'Python',
  'Java',
  'AWS',
  'Docker',
  'Kubernetes',
  'GraphQL',
  'REST APIs',
  'SQL',
  'MongoDB',
  'Git',
  'CI/CD',
  'HTML/CSS',
  'Vue.js',
  'Angular',
  'Ruby on Rails',
  'PHP',
  'Swift',
  'Kotlin',
  'Flutter',
  'React Native',
  'Machine Learning',
  'Data Analysis',
  'DevOps',
  'Cloud Architecture'
] as const;

// Soft skills for job postings
export const SOFT_SKILLS = [
  'Communication',
  'Leadership',
  'Problem Solving',
  'Team Collaboration',
  'Time Management',
  'Critical Thinking',
  'Adaptability',
  'Project Management',
  'Mentoring',
  'Conflict Resolution',
  'Decision Making',
  'Presentation Skills',
  'Strategic Thinking',
  'Emotional Intelligence',
  'Customer Focus',
  'Innovation',
  'Analytical Skills',
  'Attention to Detail'
] as const;

// Skill categories for user profiles and course skills
const SKILL_CATEGORIES = {
  'Technology & Digital': [
    'Data Analysis',
    'SQL',
    'Excel (Advanced)',
    'Tableau',
    'Python',
    'AI & Machine Learning',
    'Cloud Computing',
    'Cybersecurity',
    'Software Development',
    'Mobile Development',
    'Web Development',
    'UX/UI Design',
    'DevOps'
  ],
  'Business & Management': [
    'Project Management',
    'Risk Management',
    'Product Management',
    'Digital Marketing',
    'Sales',
    'Financial Modeling',
    'Market Analysis',
    'Negotiation'
  ],
  'Leadership & Interpersonal': [
    'Team Leadership',
    'Communication',
    'Problem Solving',
    'Strategic Thinking',
    'Decision Making',
    'Mentoring',
    'Conflict Resolution'
  ]
} as const;

// Flatten skills array for dropdown while preserving categories
const AVAILABLE_SKILLS = Object.entries(SKILL_CATEGORIES).flatMap(
  ([category, skills]) => skills.map(skill => ({
    category,
    name: skill
  }))
).sort((a, b) => a.name.localeCompare(b.name));